(() => {
 const init = (root = document) => {
  root.querySelectorAll('[data-mc-product]').forEach(module => {
   if (module.dataset.ready) return;
   module.dataset.ready = 'true';
   const form = module.querySelector('form[action*="cart/add"]');
   if (!form) return;
   const select = form.querySelector('[data-mc-variant-select]');
   const hidden = form.querySelector('[data-mc-variant-id]');
   const quantity = form.querySelector('[data-mc-quantity]');
   const add = form.querySelector('[data-mc-add]');
   const enquiry = module.querySelector('[data-mc-enquiry]');
   const messages = module.querySelector('[data-mc-messages]').dataset;
   const isMC = module.dataset.isMc === 'true';
   const thumbs = [...module.querySelectorAll('[data-mc-image]')];
   const image = module.querySelector('.mc-commerce-featured-image');
   const changeImage = button => {
    if (!image || !button) return;
    image.src = button.dataset.imageSrc;image.srcset = button.dataset.imageSrcset;image.alt = button.dataset.imageAlt;
    thumbs.forEach(thumb => thumb.setAttribute('aria-pressed',String(thumb === button)));
   };
   thumbs.forEach(button => button.addEventListener('click',() => changeImage(button)));
   hidden.disabled = false;select.disabled = true;
   const update = (changeURL = false) => {
    const option = select.options[select.selectedIndex];
    const count = Math.max(1, Number(quantity.value) || 1);
    const multi = isMC && (count + Number(module.dataset.cartCount) > 1);
    const buyable = option.dataset.available === 'true' && Number(option.dataset.priceValue) > 0;
    hidden.value = option.value;
    module.querySelector('[data-mc-price]').textContent = Number(option.dataset.priceValue) > 0 ? option.dataset.price : messages.quoteLabel;
    const basis = module.querySelector('[data-mc-price-basis]');if(basis)basis.hidden = Number(option.dataset.priceValue) <= 0;
    module.querySelector('[data-mc-sku]').textContent = option.dataset.sku;
    module.querySelector('[data-mc-availability]').textContent = Number(option.dataset.priceValue) <= 0 ? messages.quoteStatus : (buyable ? messages.availableStatus : messages.soldOut);
    add.textContent = multi ? messages.multiLabel : messages.addLabel;
    add.disabled = !buyable && !multi;
    const note = module.querySelector('[data-mc-order-guidance]');if(note)note.textContent = multi ? messages.multiNote : messages.singleNote;
    const url = new URL(enquiry.dataset.contactUrl,location.origin);
    url.searchParams.set('model',`${option.dataset.sku || module.dataset.productTitle} × ${count}`);
    if(multi)url.searchParams.set('purpose','multiple');
    enquiry.href = url.pathname+url.search;
    if(changeURL){const current = new URL(location.href);current.searchParams.set('variant',option.value);history.replaceState({},'',current);}
    if(option.dataset.image)changeImage(thumbs.find(button => button.dataset.mcImage === option.dataset.image));
   };
   select.disabled = false;select.removeAttribute('name');
   select.addEventListener('change',() => update(true));quantity.addEventListener('input',() => update());
   form.addEventListener('submit',event => {
    const count = Math.max(1,Number(quantity.value)||1);
    if(isMC && count + Number(module.dataset.cartCount) > 1){event.preventDefault();location.assign(enquiry.href);return;}
    if(add.disabled){event.preventDefault();return;}
    window.dataLayer = window.dataLayer || [];window.dataLayer.push({event:'mc_add_to_cart_intent',variant_id:hidden.value,quantity:count,page_path:location.pathname});
   });
   update();
  });
  root.querySelectorAll('[data-mc-cart]').forEach(module => {
   if(module.dataset.ready)return;module.dataset.ready='true';
   const form = module.querySelector('[data-mc-cart-update]');if(!form)return;
   let dirty = false;
   const checkout = module.querySelector('[data-mc-checkout]');
   form.addEventListener('input',() => {dirty=true;if(checkout)checkout.disabled=true;module.querySelector('[data-mc-cart-change-note]').hidden=false;});
   module.querySelector('[data-mc-checkout-form]')?.addEventListener('submit',event => {if(dirty){event.preventDefault();form.querySelector('[name=update]').focus();}});
   const enquiry = module.querySelector('[data-mc-cart-enquiry]');
   enquiry?.addEventListener('click',event => {if(dirty){event.preventDefault();form.querySelector('[name=update]').focus();module.querySelector('[data-mc-cart-change-note]').hidden=false;}});
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',() => init());else init();
 document.addEventListener('shopify:section:load',event => init(event.target));
})();
